(() => {
  'use strict';
  const configNode = document.getElementById('ThemeConfig');
  if (!configNode) return;
  const C = JSON.parse(configNode.textContent);
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const money = value => new Intl.NumberFormat(C.locale, { style: 'currency', currency: C.currency }).format(value / 100);
  const say = text => { const el = $('#GlobalStatus'); if (el) el.textContent = text; };
  const errors = (selector, message, root = document) => $$(selector, root).forEach(el => { el.textContent = message; el.hidden = !message; });
  const returningFocus = new WeakMap();
  function openDialog(dialog, trigger) {
    if (!dialog || dialog.open) return;
    $$('dialog[open]').forEach(d => d.close());
    returningFocus.set(dialog, trigger || document.activeElement);
    dialog.showModal();
    const input = $('input:not([type=hidden]),button,a[href]', dialog);
    input?.focus({ preventScroll: true });
  }
  document.addEventListener('close', e => {
    if (!(e.target instanceof HTMLDialogElement)) return;
    const target = returningFocus.get(e.target);
    if (target?.isConnected) target.focus({ preventScroll: true });
    if (e.target.id === 'NewsletterDialog') rememberNewsletter();
  }, true);
  document.addEventListener('click', e => {
    const close = e.target.closest('[data-close]');
    if (close) close.closest('dialog')?.close();
    const open = e.target.closest('[data-open]');
    if (open) { e.preventDefault(); openDialog(document.getElementById(open.dataset.open), open); }
    if (e.target instanceof HTMLDialogElement) {
      const r = e.target.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) e.target.close();
    }
  });
  document.addEventListener('change', e => {
    if (e.target.matches('[data-localization],[data-autosubmit]')) e.target.form.requestSubmit();
  });
  const productStates = new WeakMap();
  function initProduct(root) {
    if (productStates.has(root)) return;
    const form = $('[data-product-form]', root);
    const source = $('[data-variants]', root);
    if (!form || !source) return;
    const variants = JSON.parse(source.textContent);
    const state = { variants, form, current: null };
    productStates.set(root, state);
    if (new URL(location.href).searchParams.get('offre') === 'duo') {
      const duo = $('[data-bundle-card] [data-offer]:not(:disabled)', root);
      if (duo) duo.checked = true;
    }
    updateProduct(root, false);
    const cta = $('.product-purchase', root);
    const sticky = $('[data-sticky-purchase]', root);
    if (sticky && cta) {
      state.observer = new IntersectionObserver(entries => {
        const r = entries[0].boundingClientRect;
        sticky.hidden = entries[0].isIntersecting || r.top > 0;
      });
      state.observer.observe(cta);
    }
  }
  function updateProduct(root, updateURL = true) {
    const state = productStates.get(root);
    if (!state) return;
    const choices = $$('[data-option-index]', root).map(f => $('input:checked', f)?.value);
    const variant = choices.length ? state.variants.find(v => v.options.every((x, i) => x === choices[i])) : state.variants.find(v => String(v.id) === $('[data-variant-id]', root)?.value);
    state.current = variant;
    const native = $('[data-variant-id]', root);
    if (variant) native.value = variant.id;
    native.disabled = !variant;
    $$('[data-option-index]', root).forEach((fieldset, i) => {
      $('[data-option-label]', fieldset).textContent = choices[i] || '';
      $$('input[type=radio]', fieldset).forEach(input => {
        input.disabled = !state.variants.some(v => v.available && v.options[i] === input.value && v.options.slice(0, i).every((x, j) => x === choices[j]));
      });
    });
    const price = $('[data-product-price]', root);
    if (price && variant) {
      price.replaceChildren();
      const wrap = document.createElement('span'); wrap.className = 'price';
      if (variant.compare > variant.price) { const s = document.createElement('s'); s.textContent = variant.compareFormatted; wrap.append(s); }
      const current = document.createElement('span'); current.className = 'price-current'; current.textContent = variant.formatted; wrap.append(current); price.append(wrap);
    }
    if (price && !variant) price.textContent = C.strings.unavailable;
    const sku = $('[data-sku]', root); if (sku) sku.textContent = variant?.sku || '';
    const stock = $('[data-stock]', root); if (stock) { stock.hidden = !variant?.available || variant.inventory === null; stock.textContent = variant?.inventory !== null ? `${variant?.inventory || 0} en stock` : ''; }
    const single = $('[data-single-price]', root); if (single) single.textContent = variant ? variant.formatted : '—';
    if (updateURL && variant) {
      const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
      if (variant.media) showMedia(root, variant.media);
    }
    updateOffer(root);
  }
  function updateOffer(root) {
    const state = productStates.get(root);
    if (!state) return;
    const v = state.current;
    $$('[data-bundle-card]', root).forEach(card => {
      const option = $('[data-bundle-variant]', card)?.selectedOptions[0];
      const choice = $('[data-offer]', card);
      choice.disabled = !option || option.disabled;
      const subtotal = (v?.price || 0) * Number(choice.dataset.primaryQuantity) + Number(option?.dataset.price || 0) * Number($('[data-bundle-variant]', card)?.dataset.secondaryQuantity || 1);
      const discount = Math.min(Number(card.dataset.secondaryDiscount || 0), Number(option?.dataset.price || 0)) * Number($('[data-bundle-variant]', card)?.dataset.secondaryQuantity || 1);
      $('[data-offer-price]', card).textContent = v ? money(subtotal - discount) : '—';
    });
    const offer = $('[data-offer]:checked', root);
    const card = offer?.closest('[data-bundle-card]');
    const secondary = card ? $('[data-bundle-variant]', card) : null;
    const quantity = Number($('[name=quantity]', state.form).value);
    let total = (v?.price || 0) * Number(offer?.dataset.primaryQuantity || 1);
    if (secondary) total += Math.max(0, Number(secondary.selectedOptions[0]?.dataset.price || 0) - Number(card.dataset.secondaryDiscount || 0)) * Number(secondary.dataset.secondaryQuantity);
    $$('[data-addon]:checked', root).forEach(input => { total += Number(input.dataset.price); });
    total *= Number.isInteger(quantity) && quantity > 0 ? quantity : 1;
    const available = !!v?.available && (!secondary || (secondary.selectedOptions[0] && !secondary.selectedOptions[0].disabled));
    $$('[data-add-label]', root).forEach(el => { el.textContent = !v ? C.strings.unavailable : available ? C.strings.add : C.strings.soldOut; });
    $$('.product-submit,[data-submit-product]', root).forEach(button => { button.disabled = !available || cartBusy; });
    $('[data-selection-total]', root).textContent = v ? money(total) : '—';
    const stickyPrice = $('[data-sticky-price]', root); if (stickyPrice) stickyPrice.textContent = v ? money(total) : '—';
    const dynamic = $('[data-dynamic-checkout]', root); if (dynamic) dynamic.hidden = !!card || $$('[data-addon]:checked', root).length > 0 || !available;
  }
  function showMedia(root, id) {
    const slide = $$('[data-media-id]', root).find(el => String(el.dataset.mediaId) === String(id));
    const track = $('.gallery-track', root);
    if (!slide || !track) return;
    track.scrollTo({ left: slide.offsetLeft - track.firstElementChild.offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    $$('[data-gallery-target]', root).forEach(el => el.setAttribute('aria-current', String(el.dataset.galleryTarget === String(id))));
    $$('video', track).forEach(video => { if (!slide.contains(video)) video.pause(); });
  }
  document.addEventListener('change', e => {
    const root = e.target.closest('[data-product-section]');
    if (!root) return;
    if (e.target.closest('[data-variant-picker]')) updateProduct(root);
    else if (e.target.matches('[data-offer],[data-bundle-variant],[data-addon],[name=quantity]')) {
      if (e.target.matches('[data-offer]')) {
        const url = new URL(location.href);
        if (e.target.closest('[data-bundle-card]')) url.searchParams.set('offre', 'duo');
        else url.searchParams.delete('offre');
        history.replaceState({}, '', url);
      }
      updateOffer(root);
    }
  });
  document.addEventListener('click', e => {
    const thumb = e.target.closest('[data-gallery-target]');
    if (thumb) showMedia(thumb.closest('[data-product-section]'), thumb.dataset.galleryTarget);
    const step = e.target.closest('[data-step]');
    if (step) { const input = $('input', step.parentElement); const value = Number(input.value) || 1; input.value = Math.max(Number(input.min) || 1, value + Number(step.dataset.step)); input.dispatchEvent(new Event('change', { bubbles: true })); }
    const sticky = e.target.closest('[data-submit-product]');
    if (sticky) $('[data-product-form]', sticky.closest('[data-product-section]'))?.requestSubmit();
    const carousel = e.target.closest('[data-carousel-step]');
    if (carousel) {
      const track = $('.ugc-track,.review-track', carousel.closest('[data-carousel]'));
      track?.scrollBy({ left: track.clientWidth * .8 * Number(carousel.dataset.carouselStep), behavior: 'smooth' });
    }
  });
  document.addEventListener('input', e => {
    if (e.target.matches('[data-comparison-range]')) e.target.closest('[data-comparison]').style.setProperty('--position', `${e.target.value}%`);
  });
  let cartBusy = false;
  let lockStates = new Map();
  function lockCart(locked) {
    cartBusy = locked;
    if (locked) {
      lockStates = new Map();
      $$('[data-checkout],[data-cart-step],[data-cart-quantity],.product-submit,[data-submit-product]').forEach(el => { lockStates.set(el, el.disabled); el.disabled = true; });
    } else {
      lockStates.forEach((disabled, el) => { if (el.isConnected) el.disabled = disabled; });
      lockStates.clear();
      $$('[data-product-section]').forEach(updateOffer);
    }
    $$('[data-cart-content],[data-main-cart]').forEach(el => el.setAttribute('aria-busy', String(locked)));
  }
  function sectionIDs() { return ['cart-panel', $('[data-main-cart]')?.dataset.sectionId].filter(Boolean); }
  async function requestJSON(url, options = {}) {
    const response = await fetch(url, { credentials: 'same-origin', ...options, headers: { Accept: 'application/json', ...options.headers } });
    let data;
    try { data = await response.json(); } catch { throw new Error(C.strings.error); }
    if (!response.ok || data.status >= 400) throw new Error(data.description || data.message || C.strings.error);
    return data;
  }
  function renderCart(sections) {
    const doc = new DOMParser();
    const drawerHTML = sections?.['cart-panel'];
    if (!drawerHTML) return false;
    const parsed = doc.parseFromString(drawerHTML, 'text/html');
    const content = $('[data-cart-content]', parsed);
    if (!content) return false;
    const oldContent = $('#CartDialog [data-cart-content]');
    oldContent.replaceWith(content);
    const count = Number(content.dataset.count);
    $$('[data-cart-count]').forEach(el => { el.textContent = count; if (el.closest('.cart-link')) el.hidden = count === 0; });
    const main = $('[data-main-cart]');
    if (main) {
      const pageHTML = sections[main.dataset.sectionId];
      const next = pageHTML ? $('[data-main-cart]', doc.parseFromString(pageHTML, 'text/html')) : null;
      if (!next) return false;
      main.replaceWith(next);
    }
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: count } }));
    return true;
  }
  async function refreshCart(sections) {
    if (sections && renderCart(sections)) return;
    const url = new URL(C.root, location.origin); url.searchParams.set('sections', sectionIDs().join(','));
    const result = await requestJSON(url);
    if (!renderCart(result)) throw new Error(C.strings.syncError);
  }
  async function changeCart(key, quantity, inputID) {
    if (cartBusy) return;
    if (!Number.isInteger(quantity) || quantity < 0) { errors('[data-cart-error]', C.strings.quantityError); return; }
    errors('[data-cart-error]', ''); lockCart(true);
    try {
      const data = await requestJSON(C.change, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity, sections: sectionIDs(), sections_url: location.pathname }) });
      try { await refreshCart(data.sections); } catch { throw new Error(C.strings.syncError); }
      say(C.strings.updated);
      if (inputID) document.getElementById(inputID)?.focus({ preventScroll: true });
    } catch (error) { try { await refreshCart(); } catch {} errors('[data-cart-error]', error.message); }
    finally { lockCart(false); }
  }
  document.addEventListener('click', async e => {
    const cartOpen = e.target.closest('[data-cart-open]');
    if (cartOpen && C.mode === 'drawer') {
      e.preventDefault(); openDialog($('#CartDialog'), cartOpen);
      if (!cartBusy) { lockCart(true); try { await refreshCart(); } catch (error) { errors('[data-cart-error]', error.message); } finally { lockCart(false); } }
    }
    const remove = e.target.closest('[data-cart-remove]');
    if (remove) { e.preventDefault(); if (!cartBusy) changeCart(remove.closest('[data-line-key]').dataset.lineKey, 0); }
    const step = e.target.closest('[data-cart-step]');
    if (step && !cartBusy) { const item = step.closest('[data-line-key]'); const input = $('[data-cart-quantity]', item); changeCart(item.dataset.lineKey, Math.max(0, Number(input.value) + Number(step.dataset.cartStep)), input.id); }
  });
  document.addEventListener('change', e => {
    if (e.target.matches('[data-cart-quantity]')) changeCart(e.target.closest('[data-line-key]').dataset.lineKey, Number(e.target.value), e.target.id);
  });
  document.addEventListener('submit', async e => {
    const form = e.target;
    if (!form.matches('[data-product-form]')) return;
    e.preventDefault(); if (cartBusy) return;
    const root = form.closest('[data-product-section]'); const state = productStates.get(root);
    if (!state?.current?.available) return;
    const quantity = Number($('[name=quantity]', form).value);
    if (!Number.isInteger(quantity) || quantity < 1) { errors('[data-product-error]', C.strings.quantityError, root); return; }
    const offer = $('[data-offer]:checked', form);
    const items = [{ id: state.current.id, quantity: quantity * Number(offer?.dataset.primaryQuantity || 1) }];
    const card = offer?.closest('[data-bundle-card]');
    if (card) {
      const select = $('[data-bundle-variant]', card);
      if (!select.selectedOptions[0] || select.selectedOptions[0].disabled) return;
      items.push({ id: Number(select.value), quantity: quantity * Number(select.dataset.secondaryQuantity) });
    }
    $$('[data-addon]:checked', root).forEach(input => items.push({ id: Number(input.value), quantity }));
    const properties = {};
    new FormData(form).forEach((value, key) => { const match = key.match(/^properties\[(.+)\]$/); if (match && typeof value === 'string') properties[match[1]] = value; });
    if (Object.keys(properties).length) items[0].properties = properties;
    const sellingPlan = $('[name=selling_plan]', form)?.value;
    if (sellingPlan) items[0].selling_plan = Number(sellingPlan);
    errors('[data-product-error]', '', root); errors('[data-cart-error]', ''); lockCart(true);
    let added = false;
    try {
      const result = await requestJSON(C.add, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items, sections: sectionIDs(), sections_url: location.pathname }) });
      added = true;
      if (C.mode === 'page') { location.assign(C.cart); return; }
      await refreshCart(result.sections);
      openDialog($('#CartDialog'), $('.product-submit', root)); say(C.strings.added);
    } catch (error) {
      if (added) { openDialog($('#CartDialog'), $('.product-submit', root)); errors('[data-cart-error]', C.strings.syncError); }
      else { errors('[data-product-error]', error.message, root); try { await refreshCart(); } catch {} }
    } finally { lockCart(false); }
  });
  let noteTimer;
  document.addEventListener('input', e => {
    if (!e.target.matches('[data-cart-note]')) return;
    clearTimeout(noteTimer); const value = e.target.value;
    noteTimer = setTimeout(async () => {
      try { await requestJSON(C.root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: value }) }); }
      catch (error) { errors('[data-cart-error]', error.message); }
    }, 450);
  });
  let searchTimer, searchAbort;
  document.addEventListener('input', e => {
    if (!e.target.matches('[data-predictive]')) return;
    clearTimeout(searchTimer); searchAbort?.abort();
    const query = e.target.value.trim(); const out = $('#PredictiveResults'); out.replaceChildren();
    if (query.length < 2) return;
    searchTimer = setTimeout(async () => {
      searchAbort = new AbortController();
      const url = new URL(C.predictive, location.origin); url.searchParams.set('q', query); url.searchParams.set('resources[type]', 'product'); url.searchParams.set('resources[limit]', '5'); url.searchParams.set('section_id', 'predictive-search');
      try {
        const response = await fetch(url, { signal: searchAbort.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error();
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        if ($('#SearchInput').value.trim() !== query) return;
        const section = $('#shopify-section-predictive-search', html);
        out.replaceChildren(...(section || html.body).childNodes);
      } catch (error) { if (error.name !== 'AbortError') out.textContent = ''; }
    }, 220);
  });
  function countdown() {
    $$('[data-countdown]').forEach(el => {
      const deadline = Date.parse(el.dataset.countdown);
      if (!Number.isFinite(deadline)) { el.hidden = true; return; }
      const seconds = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
      el.hidden = !seconds;
      if (!seconds) { el.closest('.campaign-end')?.setAttribute('hidden', ''); return; }
      const hours = Math.floor(seconds / 3600), minutes = Math.floor(seconds / 60) % 60;
      el.textContent = [hours, minutes, seconds % 60].map(n => String(n).padStart(2, '0')).join(':');
    });
  }
const newsletterKey = 'lorehaven-newsletter-v1';
  function rememberNewsletter() { try { localStorage.setItem(newsletterKey, String(Date.now())); } catch {} }
  function initNewsletter() {
    const dialog = $('#NewsletterDialog'); if (!dialog || dialog.dataset.initialized || window.Shopify?.designMode) return;
    dialog.dataset.initialized = 'true';
    let last = 0; try { last = Number(localStorage.getItem(newsletterKey)); } catch {}
    if (Date.now() - last < Number(dialog.dataset.newsletterDays) * 86400000) return;
    let ready = false, shown = false;
    const show = () => {
      if (!ready || shown || document.visibilityState !== 'visible' || $('dialog[open]') || document.activeElement?.matches('input,textarea,select') || location.pathname.includes('/cart')) return;
      shown = true; rememberNewsletter(); openDialog(dialog);
    };
    setTimeout(() => { ready = true; if (dialog.dataset.newsletterExit !== 'true' || !matchMedia('(hover:hover)').matches) show(); }, Number(dialog.dataset.newsletterDelay) * 1000);
    if (dialog.dataset.newsletterExit === 'true') document.addEventListener('mouseout', e => { if (e.clientY <= 0 && !e.relatedTarget) show(); });
  }
  function init(root = document) { $$('.review-form-panel', root).forEach(panel => { if ($('.form-success,.errors', panel)) panel.open = true; }); $$('[data-product-section]', root).forEach(initProduct); countdown(); initNewsletter(); }
  document.addEventListener('shopify:section:load', () => init());
  document.addEventListener('shopify:section:unload', e => { $$('[data-product-section]', e.target).forEach(root => productStates.get(root)?.observer?.disconnect()); });
  document.addEventListener('shopify:section:select', e => { if (e.target.contains($('#NewsletterDialog'))) openDialog($('#NewsletterDialog')); });
  document.addEventListener('shopify:section:deselect', () => $('#NewsletterDialog')?.close());
  init(); setInterval(countdown, 1000);
})();
